import * as React from 'react';
import { useHistory } from 'react-router-dom';
import {
  CardContainer,
  HeaderContainer,
  FooterContainer,
  CardDescription,
  CardTitle,
  BodyContainer,
  BlueRectangle,
  ServiceTreeNameText,
  InfoContainer,
  BodyLeftContainer,
  BodyDivider,
  NameLink,
  AddRequestLink,
} from '../../Common/Styles/homeCards.styled';
import { useGetDataOwnersForHome } from '../../Hooks/Home/useGetDataOwnersForHome';
import { DefaultButton, PrimaryButton, Spinner, SpinnerSize } from '@fluentui/react';
import { DataOwnerRecord } from '../../Common/DataOwnerModels/DataOwnerRecord';

export function DataOwnerCard(): React.ReactElement {
  const history = useHistory();

  const [dataOwnerList, dataOwnerListLoading] = useGetDataOwnersForHome();

  const handleViewAllDataOwnerButton = (): void => {
    history.push('/dataOwners');
  };
  const handleAddNewDataOwnerButton = () => {
    history.push('/dataOwners/addNew');
  };

  const renderNameLink = (dataOwner: DataOwnerRecord) => {
    return (
      <NameLink
        to={`/dataOwners/${dataOwner.id}`}
        title=""
        target="_blank"
        usageEvent={{
          feature: 'HRDP',
          subFeature: 'HRDP.Home.ViewDataOwner',
        }}
      >
        {dataOwner.name}
      </NameLink>
    );
  };

  const renderAddRequestLink = (dataOwner: DataOwnerRecord) => {
    return (
      <AddRequestLink
        to={`/dataOwners/${dataOwner.id}/addNew`}
        title=""
        target="_blank"
        usageEvent={{
          feature: 'HRDP',
          subFeature: 'HRDP.Home.AddDataOwnerRequest',
        }}
      >
        Add Request
      </AddRequestLink>
    );
  };

  return (
    <>
      <CardContainer>
        <HeaderContainer>
          <CardTitle>Data Owners</CardTitle>
          <CardDescription>
            The DataOwner Onboarding portal enables dataOwner to onboard onto HR Data Platform and publish data.
          </CardDescription>
        </HeaderContainer>

        {dataOwnerList.length > 0 &&
          dataOwnerList.map((dataOwner: DataOwnerRecord) => (
            <div key={dataOwner.id}>
              <BodyContainer>
                <BodyLeftContainer>
                  <BlueRectangle />
                  <InfoContainer>
                    {renderNameLink(dataOwner)}
                    <ServiceTreeNameText>{dataOwner.serviceTreeName}</ServiceTreeNameText>
                  </InfoContainer>
                </BodyLeftContainer>
                {renderAddRequestLink(dataOwner)}
              </BodyContainer>
              <BodyDivider />
            </div>
          ))}

        <FooterContainer>
          <PrimaryButton
            text={'View all Data Owners'}
            disabled={dataOwnerListLoading}
            onClick={handleViewAllDataOwnerButton}
            checked={false}
          />
          <DefaultButton
            text={'Add Data Owner'}
            disabled={dataOwnerListLoading}
            onClick={handleAddNewDataOwnerButton}
            checked={false}
          />
          {dataOwnerListLoading && <Spinner size={SpinnerSize.medium} />}
        </FooterContainer>
      </CardContainer>
    </>
  );
}
